import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

/**
 * /login -> kicks off Shopify New Customer Accounts OAuth (backend-mediated).
 * After login the user lands back on the on-brand /account page.
 */
export default function ShopifyAccountRedirect() {
  useEffect(() => {
    window.location.replace(api.accountLoginUrl("/account"));
  }, []);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 bg-[var(--acx-bg)] text-white/60" data-testid="account-redirect">
      <Loader2 size={22} className="animate-spin text-[#E11B22]" />
      <p className="text-[14px]">Taking you to secure sign in…</p>
    </div>
  );
}
